import React, { useState } from "react";
import { download3 } from "react-icons-kit/icomoon/download3";
import { ic_check_circle } from "react-icons-kit/md/ic_check_circle";
import Icon from "react-icons-kit";
import ApiCalls from "../../apis/api-calls";
import Utility from "../../../common/utility";

const DownloadState = ({ downloadFile, val, upgradeVersion }) => {
  const [downloaded, setDownloaded] = useState(false);
  const trackFile = (version, filename) => {
    ApiCalls.trackDownload({
      company_id: Utility.getData("companyId"),
      user_id: Utility.getData("userId"),
      version: version,
      filename: filename
    });
  };
  return (
    <div>
      {!downloaded && (
        <div>
          <button
            className="downloadButton custDwnBtn"
            onClick={() => {
              trackFile(upgradeVersion, val);
              if (upgradeVersion.split(".").length === 3) {
                downloadFile(1, upgradeVersion, val);
              }
              if (upgradeVersion.split(".").length === 4) {
                downloadFile(2, upgradeVersion, val);
              }
              setDownloaded(true);
            }}
          >
            <Icon size={20} icon={download3} />
          </button>
          <label htmlFor="vehicle1">{val}</label>
          <br />
        </div>
      )}
      {downloaded && (
        <div>
          <button className="downloadButton custDwnBtn">
            <Icon size={20} icon={ic_check_circle} />
          </button>
          <label htmlFor="vehicle1">{val}</label>
          <br />
        </div>
      )}
    </div>
  );
};

export default DownloadState;



// WEBPACK FOOTER //
// ./src/components/Profile/UpgradeComponent/DownloadState.js